import { memo } from 'react';
import GenericIcon from './GenericIcon';

export default memo((params) => (
  <GenericIcon {...params}>
    <path d="M12 5V19" />
    <path d="M5 12H19" />
  </GenericIcon>
));
